import { Contact } from '../types/Contact';

export const contacts: Contact[] = [
  {
    name: 'Ghost Matoka',
    image: 'Motoko.jpg',
    id: 'dev-0',
    telegramLink: 'https://t.me/anastasiia_nih',
    github: 'https://github.com/matoka02',
    email: 'a.m.nigomedzyanova@gmail.com',
    linkedIn: 'www.linkedin.com/in/tessa02/',
    motto: 'Do. Or do not. There is no try.',
  },
];
